import { render } from "./EconomicSectors.vue?vue&type=template&id=f23b3350&scoped=true&ts=true"
import script from "./EconomicSectors.vue?vue&type=script&lang=ts"
export * from "./EconomicSectors.vue?vue&type=script&lang=ts"

import "./EconomicSectors.vue?vue&type=style&index=0&id=f23b3350&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f23b3350"]])

export default __exports__